import { UserRole } from "../Enums/companyStatus";
import { hasRole } from "./authHelpers";

const STORAGE_KEY = "voices_workspace_id";
const HEADER = "X-Voices-Workspace";

export const getVoicesWorkspaceId = (): number | null => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? Number(stored) : null;
};

export const setVoicesWorkspaceId = (workspaceId: number) => {
  localStorage.setItem(STORAGE_KEY, String(workspaceId));
};

// Admins choose the workspace in the Voices header; everyone else always works
// in their own, which the server takes from their account.
export const voicesHeaders = (): Record<string, string> => {
  const workspaceId = getVoicesWorkspaceId();
  if (!hasRole(UserRole.ADMIN) || workspaceId === null) return {};
  return { [HEADER]: String(workspaceId) };
};
